export default {
    REMOVE_INDEX: 'SpecChipRemoveByIndex',
};
